import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Checkbox } from '@material-ui/core';
// import { NameTextField } from '../../../../../../styling/Styles';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

const AdvancedSelect2 = ({ annotationName, selectedProject }) => {
  const [annotations, setAnnotations] = useState([{}]);
  const [annotationTargets, setAnnotationTargets] = useState([]);
  const [annotationTarget, setAnnotationTarget] = useState('attribute');
  /** this is introduced since importing the entity name from EditPopUpCore does
   *   not work */
  const [entityName, setEntityName] = useState('');
  useEffect(() => {
    if (selectedProject === '-1') return;
    setAnnotations(
      JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations
    );
  }, [selectedProject]);

  useEffect(() => {
    if (!Array.isArray(annotations)) return;
    setEntityName(
      annotations.filter((annotation) => annotation.annotationName === annotationName)[0]
        ?.annotationLink || ''
    );
  }, [annotations]);

  useEffect(() => {
    if (!Array.isArray(annotations)) return;
    setAnnotationTargets(
      annotations.filter((annotation) => {
        let flag = annotation.annotationLink === entityName;
        flag = flag && annotation.attributeType === 'entity';
        return flag;
      })
    );
  }, [entityName]);

  const hrefChecked = true;

  const selectTarget = (option) => {
    setAnnotationTarget(option);
  };
  const blueFontColor = { color: '#0c4d82' };
  return (
    <div className={clsx('spacingTopDiv')}>
      <Checkbox
        checked={hrefChecked}
        style={blueFontColor}
        onChange={() => {}}
        inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
      />
      &nbsp; Attach to entity: &nbsp;{' '}
      <div>
        <span style={{ display: 'inline-block', marginLeft: '1vw' }}>&nbsp;</span>
        <div style={{ display: 'inline-flex', paddingTop: '0.5vw' }}>
          <span>Select</span>
          <span style={blueFontColor}>&nbsp;{entityName}&nbsp;</span>
          <span> using the attribute &nbsp;</span>
          <span style={blueFontColor}> {annotationName}</span>
        </div>

        <span> and update its attribute</span>
        <span style={blueFontColor}>
          {' '}
          <DropdownMechanism
            target={annotationTarget}
            targets={annotationTargets.map((annotation) => annotation.annotationName)}
            selectTarget={selectTarget}
          />
        </span>
      </div>
    </div>
  );
};

export default AdvancedSelect2;
